import React from "react";
import { InfoIcon } from "lucide-react";
import { useProduct } from "contexts/ProductContext";
import { useProductAvailability } from "hooks/useProductAvailability";

import { useFeatureFlags } from "contexts/FeatureFlagContext";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import { Text } from "components/text";
import { useTranslation } from "react-i18next";
import { DetailsInfo } from "./details/DetailsInfo";

interface ProductSummaryProps {
  title: string;
  authors: string[];
  isbn: string;
  productGroupDescription: string;
}

export const ProductSummary: React.FC<ProductSummaryProps> = ({
  title,
  authors,
  isbn,
  productGroupDescription,
}) => {
  const { t } = useTranslation("productDetails");
  const { product } = useProduct();
  const { features } = useFeatureFlags();
  const { isProductActive } = useProductAvailability();

  const isActive = isProductActive(product?.supplyDetails);
  return (
    <div className="space-y-3">
      <Text as="div" variant="displaySmall" className="flex items-center gap-2">
        {title}
        {!isActive && features.inactiveBooksFilter && (
          <Tooltip>
            <TooltipTrigger>
              <InfoIcon
                className="h-6 w-6 text-system-error"
                aria-label={t("productDetails:productSummary.statusTooltip")}
                data-testid="product-inactive-icon"
              />
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <Text variant="body">
                {t("productDetails:productSummary.statusTooltip")}
              </Text>
            </TooltipContent>
          </Tooltip>
        )}
      </Text>
      <DetailsInfo
        authors={authors}
        productGroupDescription={productGroupDescription}
        isbn={isbn}
      />
    </div>
  );
};
